export default {
  placeholder: 'Wählen Sie einen Benutzer',
};
